import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { FaUserCog, FaRegStar } from "react-icons/fa";
import { PiMedal } from "react-icons/pi";
import { RiVipCrownLine } from "react-icons/ri";
import logoiii from "../../assets/logoiii.png";
import { IoMdClose } from "react-icons/io";
import { CiLogout } from "react-icons/ci";
import { IoPersonOutline } from "react-icons/io5";
import { IoIosSettings } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import { fetchUser, logout, clearAuthState } from "../../redux/slices/authSlice";
import NotificationBell from "../Notifications/NotificationBell";
import { useLocation } from "react-router-dom";

const Header = ({ onSearch }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const user = useSelector((state) => state.auth.user);
  const loggedOut = useSelector((state) => state.auth.loggedOut);
  const isAuthenticated = !!localStorage.getItem("token");

  useEffect(() => {
    if (isAuthenticated && !user) {
      dispatch(fetchUser());
    }
  }, [dispatch, user, isAuthenticated]);

  // Nuevo efecto para manejar el cierre de sesión
  useEffect(() => {
    if (loggedOut) {
      // Cerrar el menú de usuario si está abierto
      setIsOpen(false);
      // Redirigir a la página principal
      navigate("/home");
      if (location.pathname !== "/home") {
        navigate("/home");
      }
      dispatch(clearAuthState());
    }
  }, [loggedOut, navigate, dispatch, location.pathname]);

  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  // const handleLogout = () => {
  //   // Eliminar el token y limpiar el estado de autenticación usando el action creator adecuado
  //   dispatch(logout());
  //   // Redirigir a la página principal
  //   navigate("/home");
  //   dispatch(clearAuthState());
  // };

   const handleLogout = () => {
       dispatch(logout());
       navigate("/home");
       dispatch(clearAuthState());
       // 🧹 limpiar intenciones viejas
       localStorage.removeItem('nextAfterLogin');
       localStorage.removeItem('intendedPlaybackPath');
     localStorage.removeItem('intendedPlayback');
    };

  const handleProfile = () => {
    navigate("/profile");
  };

  const handleSettings = () => {
    navigate("/home");
  };

  const handleAdminDashboard = () => {
    navigate("/admin");
  };

  const handleLogoClick = () => {
    // Navigate to the home page
    navigate("/home"); // Adjust this to match your actual home page route if needed
  };

  return (
    <>
      <header className="fixed top-0 z-20 flex flex-wrap items-center justify-between w-full h-20 px-4 bg-black border-opacity-25">
        <div
          className="flex items-center cursor-pointer"
          onClick={handleLogoClick}
        >
          <h2 className="text-xl md:text-3xl font-light tracking-widest text-white text-center drop-shadow-[0_0_10px_rgba(173,216,230,0.8)] shadow-lg font-montserrat">
            EPIC
          </h2>
          <img
            src={logoiii}
            alt="Logo de EPICMOVIE"
            className="w-12 h-12 md:w-14 md:h-14"
          />
          <h2 className="text-xl md:text-3xl font-light tracking-widest text-white text-center drop-shadow-[0_0_10px_rgba(173,216,230,0.8)] shadow-lg font-montserrat">
            MOVIE
          </h2>
        </div>
        <nav>
          <ul className="flex items-center space-x-6">
            {isAuthenticated ? (
              <>
                {user?.role !== 'admin' && (
                  <li className="transition-transform duration-700 hover:text-gray-400 hover:scale-110">
                    <Link
                      to="/favoritos"
                      className="text-lg text-white ease-in-out hover:text-gray-400"
                    >
                      <FaRegStar className="w-6 h-6" />
                    </Link>
                  </li>
                )}
                {user?.role !== 'admin' && (
                  <li className="transition-transform duration-700 hover:text-gray-400 hover:scale-110">
                    <Link
                      to="/misplanes"
                      className="text-lg text-white ease-in-out hover:text-gray-400"
                      title="Mis Planes"
                    >
                      <RiVipCrownLine className="w-6 h-6" />
                    </Link>
                  </li>
                )}
                
                <li className="transition-transform duration-700 hover:text-gray-400 hover:scale-110">
                  <NotificationBell />
                </li>

                <li
                  onClick={handleModal}
                  className="text-lg text-white transition-transform duration-700 ease-in-out cursor-pointer hover:text-gray-400 hover:scale-110"
                >
                  {isOpen ? (
                    <IoMdClose className="w-6 h-6" />
                  ) : (
                    <FaUserCircle className="w-8 h-8" />
                  )}
                </li>
              </>
            ) : (
              <>
                <li className="transition-transform duration-700 hover:text-gray-400 hover:scale-110">
                  <Link
                    to="/login"
                    className="text-base text-white ease-in-out hover:text-gray-400 bg-blue-600 px-4 py-2 rounded-lg font-medium"
                  >
                    Login/Register
                  </Link>
                </li>
              </>
            )}
          </ul>
        </nav>
      </header>

      {isOpen && isAuthenticated && (
        <div
          onClick={handleModal}
          className="fixed inset-0 z-20 flex items-start justify-end h-screen top-20 bg-black/50"
        >
          <div className="relative flex items-center justify-center min-h-32 min-w-52 bg-[#242424]/70">
            <div className="flex flex-col items-end w-full gap-2 py-3 pr-5">
              <button
                onClick={handleProfile}
                className="flex items-center gap-2 text-white hover:text-gray-400"
              >
                Mi perfil <IoPersonOutline className="text-xl" />
              </button>

              {user?.role === "admin" && (
                <button
                  onClick={handleAdminDashboard}
                  className="flex items-center gap-2 text-white hover:text-gray-400"
                >
                  Admin Dashboard. <FaUserCog className="text-xl" />{" "}
                </button>
              )}
             
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 text-white hover:text-gray-400"
              >
                Cerrar sesión <CiLogout className="text-xl" />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
